// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.element-upload {\n  height: 100%;\n  width: 100%;\n  background: #C4C4C4;\n}\n.upload-label {\n  margin: 6px 0 0;\n  cursor: pointer;\n  font-size: 12px;\n}\n.upload-input {\n  display: none;\n}\n.overlay {\n  height: 100%;\n  background-color: rgba(245, 245, 245, .96);\n}\n", ""]);
// Exports
module.exports = exports;
